import React, { Dispatch } from 'react';

import pluralize from 'pluralize';

import { Alert, Box, FormControlLabel, Checkbox as MuiCheckbox } from '@mui/material';

import { Experiences } from '@luxuryescapes/contract-svc-experience';

import CuratedList from './CuratedList';
import ExperiencesFormFilters, { FiltersProps } from './ExperiencesFormFilters';
import ExperiencesList from './ExperiencesList';

interface Props extends FiltersProps {
  experiences: Array<Experiences.Offer>;
  expInFlowChecked: boolean;
  setExperiencesInFlow: Dispatch<any>;
  expCuratedChecked: boolean;
  showOnlyExperiencesCurated: boolean;
  setExperiencesCurated: Dispatch<any>;
  selectedExperiences: Array<Experiences.Offer>;
  setSelectedExperiences: Dispatch<any>;
  setShowOnlyExperiencesCurated: Dispatch<any>;
  sizePerPage: number;
  experiencesTotal: number;
  handlePage: (_, page: number) => void;
  page: number;
  isFetching: boolean;
}

function OfferExperiencesForm({
  experiences,
  expInFlowChecked,
  setExperiencesInFlow,
  expCuratedChecked,
  setExperiencesCurated,
  selectedExperiences,
  setSelectedExperiences,
  // setShowOnlyExperiencesCurated,
  // showOnlyExperiencesCurated,
  sizePerPage,
  experiencesTotal,
  handlePage,
  page,
  isFetching,
  filters,
  categories,
  resetFilters,
  setFiltersByKey,
  fieldSearchValue,
  handleFieldValue,
  handleSearchFieldValue,
  fetchExperiencesWithFilters,
  searchModeSelected,
  setSearchModeSelected,
}: Props) {
  const addExperience = (experience: Experiences.Offer) => {
    setSelectedExperiences((experiences) => [...experiences, experience]);
  };

  const removeExperience = (experience: Experiences.Offer) =>
    setSelectedExperiences((experiences) => experiences.filter((item) => item.id !== experience.id));

  return (
    <Box>
      <Box display="flex" gap={2}>
        <FormControlLabel
          control={<MuiCheckbox checked={expInFlowChecked} onChange={(e) => setExperiencesInFlow(e.target.checked)} />}
          label="Enable experiences on In-Flow"
        />
        <FormControlLabel
          control={
            <MuiCheckbox checked={expCuratedChecked} onChange={(e) => setExperiencesCurated(e.target.checked)} />
          }
          label="Enable manual curation on In-Flow?"
        />
        {/* Hidden for now */}
        {/* <FormControlLabel
          control={
            <MuiCheckbox
              checked={showOnlyExperiencesCurated}
              onChange={(e) => setShowOnlyExperiencesCurated(e.target.checked)}
            />
          }
          label="Display ONLY selected experiences"
        /> */}
      </Box>
      <Box mt={2}>
        <ExperiencesFormFilters
          filters={filters}
          categories={categories}
          resetFilters={resetFilters}
          setFiltersByKey={setFiltersByKey}
          fieldSearchValue={fieldSearchValue}
          handleFieldValue={handleFieldValue}
          handleSearchFieldValue={handleSearchFieldValue}
          fetchExperiencesWithFilters={fetchExperiencesWithFilters}
          searchModeSelected={searchModeSelected}
          setSearchModeSelected={setSearchModeSelected}
        />
      </Box>

      {!isFetching && (
        <Box mt={2}>
          <Alert severity="success">
            <strong>
              {filters?.idIn?.length > 0
                ? `${experiences.length} ${pluralize('experience', experiences.length)} found`
                : `${experiences.length} ${pluralize(
                    'experience',
                    experiences.length,
                  )} found in a range of 50 km from the hotel offer location`}
            </strong>
          </Alert>
        </Box>
      )}
      {filters?.idIn?.length > 0 && !isFetching && (
        <Box mt={2}>
          <Alert severity="warning">
            <strong>When filtering by ID, the radius filter is not applied!</strong>
          </Alert>
        </Box>
      )}

      <Box mt={2} display="grid" gap={2} gridTemplateColumns={{ sm: '1fr', md: '1fr 1fr' }}>
        <ExperiencesList
          experiences={experiences}
          handlePage={handlePage}
          currentPage={page}
          sizePerPage={sizePerPage}
          experiencesTotal={experiencesTotal}
          selectedExperiences={selectedExperiences}
          onAddExperience={addExperience}
          onRemoveExperience={removeExperience}
          isFetching={isFetching}
        />
        <CuratedList
          selectedExperiences={selectedExperiences}
          onRemoveExperience={removeExperience}
          onLoadSelectedExperiences={setSelectedExperiences}
        />
      </Box>
    </Box>
  );
}

export default OfferExperiencesForm;
